module.exports = __webpack_public_path__ + "sunsemweb/img/banner2.425bde62.png";